import styled from 'styled-components'

export const StyledTabContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
`

export const StyledTabContent = styled.div`
  flex: 1;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
`

export const StyledColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
`

export const StyledLeftColumn = styled(StyledColumn)`
  position: relative;
`

export const StyledRightColumn = styled(StyledColumn)``
